import { appSyncApolloClient } from './api.js';
import gql from 'graphql-tag';
import { useRootStore } from '../stores/root.js';
import { storeToRefs } from 'pinia';

async function createAdminLogGQL(variables) {
  return appSyncApolloClient.mutate({
    variables,
    mutation: gql`
      mutation createAdminLog(
        $orgId: String!
        $logType: String!
        $NewAdminLog: [NewAdminLog!]
      ) {
        createAdminLog(
          orgId: $orgId
          logType: $logType
          NewAdminLog: $NewAdminLog
        ) {
          PK
          SK
          message
        }
      }
    `,
  });
}

async function createAdminLog(payload) {
  try {
    const { onMobileApp, isOrgAdmin, assumingUser, orgId, userId, user } =
      storeToRefs(useRootStore());
    // Get and build user data
    const userObj = {
      userID: userId.value,
      userName: user.value.userName,
    };

    if (onMobileApp.value) userObj.onMobileApp = onMobileApp.value;
    if (isOrgAdmin.value) userObj.isOrgAdmin = isOrgAdmin.value;
    if (assumingUser.value) userObj.isAssumingUser = assumingUser.value;
    const vars = {
      orgId: payload.orgId ?? orgId.value,
      logType: payload.logType,
      NewAdminLog: {
        user: JSON.stringify(userObj),
        message: payload.message,
        endpointName: payload.endpointName,
        previousValue: JSON.stringify(payload.previousValue),
        updatedValue: JSON.stringify(payload.updatedValue),
      },
    };

    if (assumingUser.value) {
      const preAssumedUser = JSON.parse(localStorage.getItem('preAssumedUser'));
      const updateUserObj = JSON.parse(vars.NewAdminLog.user);
      updateUserObj.preAssumerUserID = preAssumedUser?.userId;
      updateUserObj.preAssumerUserName = preAssumedUser?.name;
      updateUserObj.preAssumerOrgID = preAssumedUser?.orgId;
      updateUserObj.preAssumerQsrAdmin = preAssumedUser?.qsrAdmin;
      vars.NewAdminLog.user = JSON.stringify(updateUserObj);
    }

    return await createAdminLogGQL(vars);
  } catch (error) {
    console.error('Error when trying to create admin log', error);
  }
}

export { createAdminLog };
